import React, { useEffect, useRef, useState } from "react";
import Icons from "../../../../Config/Images";
import "./styles.css";
import { Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AddressCard = ({
  shippingItem,
  billingItem,
  onEditAddress,
  isSameAddress,
  setIsSameAddress,
}) => {
  const navigate = useNavigate();
  const toggleAddressHandler = () => {
    setIsSameAddress((prev) => !prev);
  };
  const handleChangeShippingAddress = () => {
    navigate("/my-account/my-address");
  };
  const handleChangeBillingAddress = () => {
    // navigate("/my-account/my-address", );
    navigate("/my-account/my-address", {
      state: { fromChangeBillingAddress: true },
    });
  };

  const addressRefs = useRef({});
  const [tooltipMap, setTooltipMap] = useState({});

  useEffect(() => {
    const newTooltipMap = {};

    shippingItem?.forEach((e, index) => {
      const el = addressRefs.current[index];
      if (!el) return;

      newTooltipMap[index] =
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
    });

    setTooltipMap(newTooltipMap);
  }, [shippingItem]);

  return (
    <div className="address-main-container">
      <div className="address-main-card-left-container">
        <div className="address-card-container">
          <h3>Shipping Address</h3>
          {shippingItem?.map((e, index) => {
            const fullAddress = [e?.user_address_1, e?.user_address_2]
              .filter(Boolean)
              .join(", ");

            return (
              <div key={index} className="shipping-item-container">
                <div className="edit-icon-container">
                  <img
                    src={Icons.edit_icon}
                    className="edit-icon"
                    alt=""
                    onClick={() => onEditAddress("shipping", e)}
                  />
                </div>
                <p className="address-card-full-address">
                  {`${e?.user_first_name} `}
                  {/* {`${e?.user_first_name}${
                    e?.user_last_name ? ` ${e?.user_last_name}` : ""
                  }`} */}
                </p>

                {/* <p className="address-card-full-address">
                  {[
                    e?.user_address_1,
                    e?.user_address_2,
                    e?.city,
                    e?.state,
                    e?.zip_code,
                  ]
                    ?.filter(Boolean)
                    .join(", ")}
                </p> */}
                {/* <p className="address-card-full-address address-lines">
                  {[e?.user_address_1, e?.user_address_2]
                    ?.filter(Boolean)
                    .join(", ")}
                </p> */}
                <p
                  ref={(el) => (addressRefs.current[index] = el)}
                  className="address-card-full-address address-lines"
                  title={tooltipMap[index] ? fullAddress : ""}
                >
                  {fullAddress}
                </p>
                <p className="address-card-full-address">
                  {[e?.city, e?.state, e?.zip_code]?.filter(Boolean).join(", ")}
                </p>

                <p className="primary-text-color">
                  Mobile No :
                  <span className="address-card-full-address">
                    {e?.user_mobile_number}
                  </span>
                </p>
              </div>
            );
          })}
        </div>
        <div className="change-btn-main-div">
          <button
            className="change-btn-div"
            onClick={handleChangeShippingAddress}
          >
            Change Shipping Address
          </button>
        </div>

        {/* Billing Address Toggle */}
        <div className="billing-toggle-address">
          <p className="billing-same-address-text">
            Billing Address Same As Shipping
          </p>
          <Switch
            checked={isSameAddress}
            onChange={toggleAddressHandler}
            sx={{
              "& .MuiSwitch-track": {
                background: "linear-gradient(180deg, #E8EAEA 0%, #FFFFFF 100%)", // Light gradient for unchecked state
                opacity: 1,
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                background: "linear-gradient(180deg, #B88A35 0%, #855E2A 100%)", // Golden gradient for checked state
                opacity: 1,
              },
              "& .MuiSwitch-thumb": {
                background: "linear-gradient(180deg, #FFFFFF 0%, #E8EAEA 100%)", // Light gradient for thumb in unchecked state
              },
              "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
                background: "#FFFFFF", // Solid white for thumb when checked
              },
            }}
          />
        </div>
      </div>

      {/* Billing Address */}
      {!isSameAddress && billingItem && (
        <div className="address-main-card-right-container">
          <div className="address-card-container">
            <h3>Billing Address</h3>
            <div className="shipping-item-container">
              <div className="edit-icon-container">
                <img
                  src={Icons.edit_icon}
                  className="edit-icon"
                  alt=""
                  onClick={() => onEditAddress("billing", billingItem)}
                />
              </div>
              <p className="address-card-full-address">
                {`${billingItem?.user_first_name} ${
                  billingItem?.user_last_name ? billingItem?.user_last_name : ""
                }`}
              </p>

              <p className="address-card-full-address">
                {[
                  billingItem?.user_address_1,
                  billingItem?.user_address_2,
                  billingItem?.city,
                  billingItem?.state,
                  billingItem?.zip_code,
                ]
                  ?.filter(Boolean)
                  .join(", ")}
              </p>

              <p className="primary-text-color">
                Mobile No :
                <span className="address-card-full-address">
                  {billingItem?.user_mobile_number}
                </span>
              </p>
            </div>
          </div>
          <div className="change-btn-main-div">
            <button
              className="change-btn-div"
              onClick={handleChangeBillingAddress}
            >
              Change Billing Address
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddressCard;
